type TFunc = (key: string, params?: Record<string, string | number>) => string;

function relative(
  value: number,
  unit: Intl.RelativeTimeFormatUnit,
  lang: string | undefined,
  fallback: () => string,
): string {
  try {
    return new Intl.RelativeTimeFormat(lang, { numeric: 'always', style: 'short' }).format(value, unit);
  } catch {
    return fallback();
  }
}

export function timeAgo(dateStr: string, t: TFunc, lang?: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return t('time.now');
  if (mins < 60) return relative(-mins, 'minute', lang, () => t('time.minAgo', { n: mins }));
  const hours = Math.floor(mins / 60);
  if (hours < 24) return relative(-hours, 'hour', lang, () => t('time.hourAgo', { n: hours }));
  if (hours < 48) return t('time.yesterday');
  const days = Math.floor(hours / 24);
  if (days < 7) return relative(-days, 'day', lang, () => t('time.dayAgo', { n: days }));
  const weeks = Math.floor(days / 7);
  // D-415 — yedek yol da tekil hafta üretmelidir. `Intl.RelativeTimeFormat`
  // çoğulu doğru kurar, ama motorda yoksa buraya düşülür ve İngilizce/Almanca/
  // İspanyolca/Fransızca/Portekizce sözlük metni "1 weeks ago", "vor 1 Wochen"
  // gibi bozuk çıkardı. Dakika ve saat metinleri kısaltma kullandığı için
  // ("min", "h", "Std.") bu sorunu taşımaz; gün metni de tekil değere hiç
  // ulaşmaz, çünkü 48 saatin altı `time.yesterday`'e gider.
  if (weeks < 5) {
    return relative(-weeks, 'week', lang, () =>
      t(weeks === 1 ? 'time.weekAgoOne' : 'time.weekAgo', { n: weeks }));
  }
  return new Date(dateStr).toLocaleDateString(lang, { day: 'numeric', month: 'short' });
}

export function formatTime(dateStr: string, lang?: string): string {
  return new Date(dateStr).toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit' });
}
